import PatientClinicalInsight from "../types/PatientClinicalInsight";
import { ClinicalInsightValueTypes } from "../types/ClinicalInsightValueTypes";

export const clinicalInsightPrimaryValue = (
  insight: PatientClinicalInsight
): string =>
  insight.insight_values?.find(
    (v) => v.value_type === ClinicalInsightValueTypes.PRIMARY_VALUE
  )?.insight_value ?? "";

export const clinicalInsightTimestampRaw = (
  insight: PatientClinicalInsight
): string | undefined =>
  insight.insight_values?.find(
    (v) => v.value_type === ClinicalInsightValueTypes.INSIGHT_TIMESTAMP
  )?.insight_value;

/** Sort key: milestone.sort_order, then display_name (stable, matches QCard table). */
export const compareClinicalInsightsByMilestone = (
  a: PatientClinicalInsight,
  b: PatientClinicalInsight
): number =>
  a.milestone.sort_order === b.milestone.sort_order
    ? a.milestone.display_name.localeCompare(b.milestone.display_name)
    : a.milestone.sort_order - b.milestone.sort_order;

export const sortClinicalInsights = (
  insights: PatientClinicalInsight[]
): PatientClinicalInsight[] => [...insights].sort(compareClinicalInsightsByMilestone);
